import {
  prisma,
  FlowAutomationExecutionLog,
  ExecutionLogStatus,
  Flow,
} from "client";

// Create
export const createFlowAutomationExecutionLog = async (
  data: FlowAutomationExecutionLog
) => {
  try {
    const executionLog = await prisma.flowAutomationExecutionLog.create({
      data: {
        ...data,
        status: ExecutionLogStatus.PENDING,
      },
    });
    return { executionLog };
  } catch (error) {
    return { error };
  }
};

export const createManyFlowAutomationExecutionLogs = async (
  data: FlowAutomationExecutionLog[]
) => {
  try {
    const executionLogs = await prisma.flowAutomationExecutionLog.createMany({
      data: data.map((executionLog) => ({
        ...executionLog,
        status: ExecutionLogStatus.PENDING,
      })),
    });
    return { executionLogs };
  } catch (error) {
    return { error };
  }
};

// Read
export const getFlowAutomationExecutionLogsByFlowId = async (
  flowId: string
): Promise<{
  executionLogs?: FlowAutomationExecutionLog[];
  error?: any;
}> => {
  try {
    const executionLogs = await prisma.flowAutomationExecutionLog.findMany({
      where: { flowId },
    });
    return { executionLogs };
  } catch (error) {
    return { error };
  }
};

export const getFlowAutomationExecutionLogById = async (
  id: string
): Promise<{
  executionLog?: FlowAutomationExecutionLog;
  error?: any;
}> => {
  try {
    const executionLog = (await prisma.flowAutomationExecutionLog.findUnique({
      where: { id },
    })) as FlowAutomationExecutionLog;
    return { executionLog };
  } catch (error) {
    return { error };
  }
};

export const getFlowAutomationExecutionLogsByStatus = async (
  status: ExecutionLogStatus
): Promise<{
  executionLogs?: (FlowAutomationExecutionLog & {
    flow: Flow;
  })[];
  error?: any;
}> => {
  try {
    const executionLogs = await prisma.flowAutomationExecutionLog.findMany({
      where: { status },
      include: { flow: true },
      orderBy: { createdAt: "asc" },
    });
    return { executionLogs };
  } catch (error) {
    return { error };
  }
};

// Update
export const updateFlowAutomationExecutionLogById = async (
  id: string,
  data: FlowAutomationExecutionLog
): Promise<{
  executionLog?: FlowAutomationExecutionLog;
  error?: any;
}> => {
  try {
    const executionLog = await prisma.flowAutomationExecutionLog.update({
      where: { id },
      data,
    });
    return { executionLog };
  } catch (error) {
    return { error };
  }
};

export const updateFlowAutomationExecutionLogStatusById = async (
  id: string,
  status: ExecutionLogStatus
): Promise<{
  executionLog?: FlowAutomationExecutionLog;
  error?: any;
}> => {
  try {
    const executionLog = await prisma.flowAutomationExecutionLog.update({
      where: { id },
      data: { status },
    });
    return { executionLog };
  } catch (error) {
    return { error };
  }
};

// Delete
export const deleteFlowAutomationExecutionLogById = async (
  id: string
): Promise<{
  executionLog?: FlowAutomationExecutionLog;
  error?: any;
}> => {
  try {
    const executionLog = await prisma.flowAutomationExecutionLog.delete({
      where: { id },
    });
    return { executionLog };
  } catch (error) {
    return { error };
  }
};
